import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Admin shell: routed <Outlet/>. Guarded upstream by AdminRoute (and the
// server enforces requireAdmin — this is chrome, not the boundary). No
// sidebar nav — the dashboard's stat cards are the only entry point into
// each admin page, so every other page gets a "Back to Admin" link instead.
export default function AdminLayout() {
  const { pathname } = useLocation();
  const isDashboard = pathname === '/admin';
  // The print designer is a canvas tool, not a table/form page — it takes
  // more width than the standard admin container gives every other route,
  // and renders its own back link (Print.js).
  const isPrint = pathname.startsWith('/admin/print');
  // Chat interact (/admin/chat/:id, not the /admin/chat list) is a focused,
  // single-task screen. It renders its own back link + title (ChatInteract.js).
  const isChatInteract = pathname.startsWith('/admin/chat/');

  if (isPrint) {
    return (
      <section className="ss-container ss-admin--wide" style={{ paddingTop: 0, paddingBottom: 'var(--ss-space-3)' }}>
        <Outlet />
      </section>
    );
  }

  if (isChatInteract) {
    return (
      <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-6)' }}>
        <Outlet />
      </section>
    );
  }

  return (
    <section className="ss-container ss-admin" style={{ paddingBlock: 'var(--ss-space-6)' }}>
      {!isDashboard && (
        <Link to="/admin" className="ss-back-link" style={{ marginBottom: 'var(--ss-space-4)' }}>
          <ArrowLeft size={16} aria-hidden="true" /> Back to Admin
        </Link>
      )}
      <div className="ss-admin__main">
        <Outlet />
      </div>
    </section>
  );
}
